import React, { useState } from "react";
import { Button, Form, ListGroup } from "react-bootstrap";
import Select from "react-select";

function FormElement({ input, setObject }) {
  let { friendlyName, regex, errorMsg } = input;
  const [invalid, setInvalid] = useState(false);

  function regexMatch(value) {
    if (regex === "custom") {
      //remove uncounted
      var cleanValue = value.replace(/[-.& /]/g, "");
      const regex = /^(?!^([A-Za-z0-9])\1{5})[A-Za-z0-9]{6,18}$/;
      return cleanValue.match(regex) != null;
    }
    return value.match(regex) != null;
  }

  return (
    <Form.Group className="mb-3">
      <Form.Label>{friendlyName}</Form.Label>
      <Form.Control
        required={true}
        type="text"
        placeholder={`Enter a ${friendlyName.toLowerCase()}`}
        onChange={(event) => {
          const { value } = event.target;
          if (regexMatch(value)) {
            setObject(value);
            setInvalid(false);
            return;
          }
          setObject(null);
          setInvalid(true);
          return;
        }}
        isInvalid={invalid}
      />
      <Form.Control.Feedback type="invalid">
        {errorMsg ? errorMsg : `Please provide a valid ${friendlyName}.`}
      </Form.Control.Feedback>
    </Form.Group>
  );
}

function PurposeList({ purposeCodes, setPurposeVal }) {
  const formatOptionLabel = ({ value, label, customAbbreviation }) => (
    <div className="optionLabel">{label}</div>
  );
  const options = purposeCodes.map((x) => {
    return {
      value: x["Purpose Code"],
      label: x.Description,
    };
  });
  return (
    <Form.Group controlId="setCurrency" className="mb-3">
      <Form.Label>Purpose Codes</Form.Label>
      <Select
        options={options}
        isClearable={true}
        className="noborder"
        classNamePrefix="or-select"
        onChange={(x) => setPurposeVal(x ? x.value : null)}
        isSearchable={false}
        formatOptionLabel={formatOptionLabel}
      />
    </Form.Group>
  );
}

export default function ChoosePaymentAmount({
  submitEvent,
  details,
  buttonText,
  RemittanceFee,
  purposeCodes,
}) {
  const [paymentAmount, setPaymentAmount] = useState(null);
  const [reference, setReference] = useState(null);
  const [purposeVal, setPurposeVal] = useState(null);
  const [agreeChecked, setAgreeChecked] = useState(false);

  function readyToSubmit() {
    if (
      agreeChecked &&
      paymentAmount &&
      (!purposeCodes || purposeVal !== null) &&
      reference !== null
    )
      return true;
    return false;
  }

  return (
    <div>
      <Form noValidate>
        <div className="beneficiary">
          <div className="payeeicon large">
            <div className="content">
              {details["Beneficiary Name"]
                .match(/\b\w/g)
                .join("")
                .substring(0, 2)}
            </div>
          </div>
          <ListGroup variant="flush">
            {Object.keys(details).map((x, index) => (
              <ListGroup.Item key={index}>
                <span>
                  <span className="name">{x}</span>{" "}
                  {details[x].replaceAll
                    ? details[x].replaceAll(" ", "\xa0")
                    : details[x]}
                </span>
              </ListGroup.Item>
            ))}
            {/*
            <ListGroup.Item className="remittance-fee">
              <span className="name">Remittance Fee</span>&nbsp;{RemittanceFee} 
            </ListGroup.Item>
*/}
          </ListGroup>
        </div>

        <Form.Group className="mb-3" controlId="formBasicEmail">
          <FormElement
            input={{
              friendlyName: "Payment amount (e.g. 1000.00)",
              regex: "^[0-9]+([^,][0-9]{2})?$",
              propertyName: "PaymentAmount",
            }}
            setObject={(x) => setPaymentAmount(parseFloat(x))}
          />
          {/*
          <Form.Text className="text-muted">
            <div className="remittance-fee">
              <span className="name">A remittance fee of</span> {RemittanceFee} applies.
            </div>
          </Form.Text>
*/}
        </Form.Group>

        <FormElement
          input={{
            friendlyName: "Payment reference",
            regex: "custom",
            propertyName: "Reference",
            errorMsg:
              "Must consisting of at least 6 to 18 alphanumeric characters that are not all the same. Other optional allowed characters are: hyphen (-), full stop (.), ampersand (&), and forward slash (/)",
          }}
          setObject={(x) => setReference(x)}
        />

        {purposeCodes && (
          <PurposeList
            purposeCodes={purposeCodes}
            setPurposeVal={setPurposeVal}
          />
        )}

        <Form.Group>
          <Form.Check
            required
            label="I confirm above information is correct."
            feedback="You must agree before submitting."
            onChange={() => setAgreeChecked(!agreeChecked)}
          />
        </Form.Group>
      </Form>

      <Button
        variant="dark"
        block
        type="submit"
        onClick={() => submitEvent(paymentAmount, reference, purposeVal)}
        disabled={!readyToSubmit()}
      >
        {readyToSubmit() ? buttonText : "Please answer all questions"}
      </Button>
    </div>
  );
}
